import { render, staticRenderFns } from "./UiCheckboxInput.vue?vue&type=template&id=6927cbd6"
import script from "./UiCheckboxInput.vue?vue&type=script&lang=js"
export * from "./UiCheckboxInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports